import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import './index.css';
import './StringExtensions'

import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';
import * as serviceWorker from './serviceWorker';

import 'core-js';

const GLOBAL_STORE = 'global';

function getLanguage(element: HTMLElement) {
    const store = getStore(element);

    if (store === GLOBAL_STORE) return '';

    return element.getAttribute('data-language') || 'en';
}

function getStore(element: HTMLElement) {
    return element.getAttribute('data-store') ?? '';
}

const element = document.getElementById('hs-package-search');
if (element) {
    const rawTranslation = element.getAttribute('data-translations');
    const translation = rawTranslation ? JSON.parse(rawTranslation) : null;
    App({
        store: getStore(element),
        language: getLanguage(element),
        apiUrl: element.getAttribute('data-api-url') || 'https://flokk-storefront-api-prod.azurewebsites.net/',
        storefrontUrl: element.getAttribute('data-storefront-url') || 'https://store.flokk.com',
        translations: translation
    }).then(app => {
        ReactDOM.render(React.createElement(app), element);
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
